/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/resources/ts/jquery.tracking.ts");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/resources/ts/jquery.tracking.ts":
/*!*********************************************!*\
  !*** ./src/resources/ts/jquery.tracking.ts ***!
  \*********************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

///<reference types="jquery"/>
(function ($, window, document) {
    /**
     * Central tracking plugin for gathering tracking events send to AT Internet.
     */
    var Plugin = /** @class */ (function () {
        /**
         * Initializes a new instance of the plugin.
         *
         * @param element   The DOM element.
         * @param options   Plugin options.
         */
        function Plugin(element, options) {
            this.defaults = {
                mockTrackingScript: false,
                trackId: null
            };
            this.element = element;
            this.$element = $(element);
            this.isTrackingSubmitted = false;
            // extend default options
            this.options = $.extend({}, this.defaults, options);
            if (options.mockTrackingScript)
                this.mockTrackingScript();
            // init plugin if AT Internet Plugin is available
            if (window.ATInternet !== undefined && window.tag !== undefined) {
                this.tag = window.tag;
                if (!this.options.trackId) {
                    this.options.trackId = window.tag.getConfig('site');
                }
                this.init();
            }
            else {
                console.log('Tracking plugin or base tag missing. Tracking is disabled.');
            }
        }
        /**
         * Initialization.
         */
        Plugin.prototype.init = function () {
            this.initConfig();
            this.initListeners();
            this.initNoBounceHit();
        };
        /**
         * Initalize the different tracking targets, resulting in an array of configurations.
         */
        Plugin.prototype.initConfig = function () {
            this.config = [
                { selector: 'a', event: 'click', callback: 'linkClickCallback' },
                { selector: '.btn', event: 'click', callback: 'buttonClickCallback' },
                { selector: 'video', event: 'trackVideo.tracking.watched', callback: 'videoWatchedCallback' },
                { selector: 'video', event: 'trackVideo.tracking.play', callback: 'videoPlayCallback' },
                { selector: 'video', event: 'trackVideo.tracking.pause', callback: 'videoPauseCallback' },
                { selector: 'video', event: 'trackVideo.tracking.stopped', callback: 'videoStoppedCallback' },
                { selector: '.globalSearch', event: 'trackSearch.tracking.global', callback: 'globalSearchCallback' },
                { selector: '.filteredSearch', event: 'trackSearch.tracking.filtered', callback: 'filteredSearchCallback' },
                { selector: '.accordion .accordion__panel', event: 'after.open.panel.accordion', callback: 'accordionTabOpenCallback' },
                { selector: '.accordion .accordion__panel', event: 'after.close.panel.accordion', callback: 'accordionCloseCallback' },
                { selector: '.teaser', event: 'teaserClick.tracking', callback: 'teaserClickCallback' },
                { selector: 'form', event: 'submit', callback: 'formSubmitCallback' },
                { selector: '.form.form--ajax', event: 'trackFrom.tracking.submitted', callback: 'formSubmitCallback' },
                { selector: '.psfSearchResults__item a', event: 'click', callback: 'psfResultClickCallback' },
                { selector: '.psfFreeSearch', event: 'psfFreeSearch.update', callback: 'psfUpdateCallback' },
            ];
        };
        /**
         * Initalize no-bounce hit, which should occur 120s after page load.
         */
        Plugin.prototype.initNoBounceHit = function () {
            setTimeout(this.fireNoBounceHit.bind(this), 120 * 1000);
        };
        /**
         * Fire no-bounce hit.
         */
        Plugin.prototype.fireNoBounceHit = function () {
            var tag = new window.ATInternet.Tracker.Tag({ site: this.options.trackId });
            //Take page info from existing tag.
            var pageInfo = this.tag.getContext('page');
            var variant = window.trackingPageSize;
            var impression = {
                campaignId: encodeURIComponent('[Nobounce]'),
                creation: encodeURIComponent('[' + '120s' + ']'),
                format: encodeURIComponent('[' + this.getPageId() + ']'),
                generalPlacement: Plugin.prepareText('[' + document.title + ']'),
                detailedPlacement: encodeURIComponent('[' + Plugin.stripProtocol(window.location.href) + ']'),
                variant: '[' + variant + ']'
            };
            tag.publisher.set({
                impression: impression
            });
            tag.dispatch();
        };
        /**
         * Loop through tracking targets and attach listeners according to config.
         */
        Plugin.prototype.initListeners = function () {
            var $document = $(document);
            var self = this;
            var _loop_1 = function (item) {
                if (item.event) {
                    $document.on(item.event, item.selector, function (event, data) {
                        self[item.callback]($(event.currentTarget), event, data);
                    });
                }
                else {
                    $(item.selector).map(function (index, element) {
                        var $item = $(element);
                        if (item.callback) {
                            self[item.callback]($item);
                        }
                    });
                }
            };
            for (var _i = 0, _a = this.config; _i < _a.length; _i++) {
                var item = _a[_i];
                _loop_1(item);
            }
        };
        /**
         * Mock AT Internet script for development purposes.
         * Potentatially can be removed on release.
         */
        Plugin.prototype.mockTrackingScript = function () {
            console.log('Mocking AT Internet');
            window.ATInternet = {
                Tracker: {
                    Tag: function () {
                        this.click = {
                            send: function (data) {
                                console.log('mock - click - send data: ', data);
                            }
                        };
                        this.publisher = {
                            set: function (data) {
                                console.log('mock - publisher - set data: ', data);
                            }
                        };
                        this.dispatch = function () {
                            console.log('mock - dispatch');
                        };
                    }
                }
            };
            window.tag = new window.ATInternet.Tracker.Tag({ site: this.options.trackId });
        };
        /**
         * Send click tracking to tracking library.
         * @param source
         * @param clickType
         */
        Plugin.prototype.sendClickTracking = function (source, actionName, chapter2, actionType, chapter3, event) {
            var data = {
                elem: source,
                name: encodeURIComponent(actionName),
                chapter1: encodeURIComponent(Plugin.stripProtocol(window.location.href)),
                chapter2: Plugin.prepareText(chapter2),
                chapter3: Plugin.prepareText(chapter3),
                level2: this.getLevel2Id(),
                type: actionType
            };
            if (!this.tag.click.send(data))
                event.preventDefault();
        };
        Plugin.prototype.isExitLink = function (url) {
            if (url) {
                if (url.startsWith('#'))
                    return false;
                if (url.startsWith('/'))
                    return false;
                if (url.startsWith('javascript:'))
                    return false;
                if (url.startsWith('http://') || url.startsWith('https://')) {
                    if (!Plugin.stripProtocol(url).startsWith(document.domain))
                        return true;
                }
            }
            return false;
        };
        /**
         * Callback function for any link click.
         * @param $source
         * @param event
         */
        Plugin.prototype.linkClickCallback = function ($source, event) {
            // console.log('linkClickCallback');
            // return on these elements, as they have a special treatment in another callback or should not be tracked at all
            if ($source.hasClass('accordion__titleLink')
                || $source.hasClass('accordion__tabsTitleLink')
                || $source.hasClass('teaser__linkedWrap')
                || $source.hasClass('mobileNavigation__exit')
                || $source.hasClass('flyoutNavigation__close')
                || $source.hasClass('form__reloadCaptcha')
                || $source.closest('.psfSearchResults__item').length > 0
                || $source.is('a[href^="mailto:"]')
                || $source.hasClass('search-result-group__link')
                || $source.hasClass('btn'))
                return;
            //default values for regular links
            var name = 'navigation';
            var linkContext = this.getLinkContext($source);
            var chapter2 = linkContext;
            var actionType = 'navigation';
            var chapter3 = $source.text().trim();
            var elem = $source[0];
            //handle exit-links
            if (this.isExitLink($source.attr('href')))
                actionType = 'exit';
            //handle search icon differently
            if ($source.hasClass('header__searchbarToggle')) {
                chapter3 = 'search';
            }
            //handle footer social media links differently
            if ($source.parent('.footer__socialMedia').length > 0) {
                chapter3 = $source.attr('title');
            }
            //handle download differently
            var isDownload = this.detectDownloadLink($source);
            if (isDownload) {
                chapter2 = 'Download List';
                actionType = 'download';
                name = 'download';
                var linkUrl = $source.attr('href');
                var fileName = void 0;
                if (linkUrl) {
                    var splits = linkUrl.split('/');
                    if (splits.length > 0) {
                        fileName = splits[splits.length - 1];
                    }
                }
                if (fileName)
                    chapter3 = fileName;
            }
            //handle non-download links with href attribute, unless originating from main navigation
            else if (linkContext !== 'Navigation') {
                var linkUrl = $source.attr('href');
                if (linkUrl) {
                    name = linkUrl;
                }
            }
            //handle social media buttons
            var isSocialMediaShareLink = !isDownload && ($source.parent('.socialMediaSharing__button').length > 0);
            if (isSocialMediaShareLink) {
                chapter2 = 'share';
                actionType = 'exit';
                if ($source.parent('.socialMediaSharing__button--facebook').length > 0) {
                    chapter3 = 'Facebook';
                }
                else if ($source.parent('.socialMediaSharing__button--linkedIn').length > 0) {
                    chapter3 = 'LinkedIn';
                }
                else if ($source.parent('.socialMediaSharing__button--twitter').length > 0) {
                    chapter3 = 'Twitter';
                }
                else if ($source.parent('.socialMediaSharing__button--mail').length > 0) {
                    chapter3 = 'Mail';
                }
            }
            // for navigation anchors that just link to the next navigation level remove href attribute to avoid an unwanted redirect by smarttag script
            if ($source.hasClass('mobileNavigation__home') || $source.parent('.mobileNavigation--hasChildren').length || $source.parent('.firstLevelNavigation__item--hasChildren').length || $source.parent('.flyoutNavigation__site--hasChildren').length) {
                elem = undefined;
            }
            // different handling for links in filtered list
            if ($source.closest('.filteredList').length > 0) {
                var closestHeadline = this.formatClosestHeadline(this.closestHeadline($source, false));
                this.sendClickTracking(elem, name, closestHeadline, actionType, chapter3, event);
                if (isDownload) {
                    this.downloadVirtualPageView($source.attr('href'));
                }
                else {
                    this.filteredListVirtualPageView(closestHeadline);
                }
            }
            else {
                //default handling for links
                this.sendClickTracking(elem, name, chapter2, actionType, chapter3, event);
                if (isDownload)
                    this.downloadVirtualPageView($source.attr('href'));
            }
        };
        /**
         * Trys to detect context of clicked element, i.e. Content, Navigation or Footer.
         *
         * @param $source Element that has been clicked
         */
        Plugin.prototype.getLinkContext = function ($source) {
            if ($source.closest('.content').length > 0)
                return 'Content';
            else if ($source.closest('.offcanvas__area').length > 0
                || $source.closest('.header').length > 0)
                return 'Navigation';
            else if ($source.closest('.footer').length > 0)
                return 'Footer';
            else
                return 'Other';
        };
        Plugin.prototype.detectDownloadLink = function (element) {
            return element.hasClass('downloadWithPicture__link') || element.parents('.list--download').length > 0;
        };
        /**
         * Callback function for any button click.
         * @param $source
         * @param event
         */
        Plugin.prototype.buttonClickCallback = function ($source, event) {
            if ($source.attr('type') && $source.attr('type').toLowerCase() === 'submit')
                return;
            var name = 'click';
            var actionType = 'navigation';
            //handle exit-links
            if (this.isExitLink($source.attr('href')))
                actionType = 'exit';
            var chapter2 = this.getLinkContext($source);
            var chapter3 = $source.text().trim();
            var linkUrl = $source.attr('href');
            if (linkUrl) {
                name = linkUrl;
            }
            var elem = $source[0];
            if ($source.closest('form').length > 0)
                elem = undefined;
            this.sendClickTracking(elem, name, chapter2, actionType, chapter3, event);
        };
        /**
         * Callback function for the video publisher impression event.
         * @param $source
         * @param event
         * @param data
         */
        Plugin.prototype.videoWatchedCallback = function ($source, event, data) {
            // console.log('videoWatchedCallback', data);
            var tag = this.tag;
            //Take page info from existing tag.
            var pageInfo = this.tag.getContext('page');
            var percentWatched = (data.trackingMinWatchedPercentage || 0.75) * 100;
            var variant = data.videoId;
            var impression = {
                campaignId: encodeURIComponent('[Videoview]'),
                creation: encodeURIComponent('[' + percentWatched + '%]'),
                format: encodeURIComponent('[' + this.getPageId() + ']'),
                generalPlacement: Plugin.prepareText('[' + document.title + ']'),
                detailedPlacement: encodeURIComponent('[' + Plugin.stripProtocol(window.location.href) + ']'),
                variant: '[' + variant + ']'
            };
            if (data.name)
                impression.advertiserId = '[' + Plugin.prepareText(data.name) + ']';
            tag.publisher.set({
                impression: impression
            });
            tag.dispatch();
        };
        /**
         * Callback function for the video play event.
         * @param $source
         * @param event
         * @param data
         */
        Plugin.prototype.videoPlayCallback = function ($source, event, data) {
            // console.log('videoPlayCallback', data);
            var tag = this.tag;
            var durationInSeconds = Math.round(data.duration / 1000);
            tag.richMedia.add({
                mediaType: 'video',
                playerId: data.playerId,
                mediaLevel2: this.getLevel2Id(),
                mediaLabel: encodeURIComponent(data.videoId + "|" + data.name),
                duration: durationInSeconds,
                refreshDuration: Math.round(durationInSeconds / 4),
                broadcastMode: 'clip'
            });
            tag.richMedia.send({
                action: 'play',
                playerId: data.playerId,
                mediaLabel: encodeURIComponent(data.videoId + "|" + data.name)
            });
        };
        /**
         * Callback function for the video pause event.
         * @param $source
         * @param event
         * @param data
         */
        Plugin.prototype.videoPauseCallback = function ($source, event, data) {
            // console.log('videoStoppedCallback', data);
            var tag = this.tag;
            tag.richMedia.add({
                mediaType: 'video',
                playerId: data.playerId,
                mediaLevel2: this.getLevel2Id(),
                mediaLabel: encodeURIComponent(data.videoId + "|" + data.name),
                broadcastMode: 'clip'
            });
            tag.richMedia.send({
                action: 'pause',
                playerId: data.playerId,
                mediaLabel: encodeURIComponent(data.videoId + "|" + data.name)
            });
        };
        /**
         * Callback function for the video stop event.
         * @param $source
         * @param event
         * @param data
         */
        Plugin.prototype.videoStoppedCallback = function ($source, event, data) {
            // console.log('videoStoppedCallback', data);
            var tag = this.tag;
            tag.richMedia.add({
                mediaType: 'video',
                playerId: data.playerId,
                mediaLevel2: this.getLevel2Id(),
                mediaLabel: encodeURIComponent(data.videoId + "|" + data.name),
                broadcastMode: 'clip'
            });
            tag.richMedia.send({
                action: 'stop',
                playerId: data.playerId,
                mediaLabel: encodeURIComponent(data.videoId + "|" + data.name)
            });
        };
        /**
         * Callback for any global search interaction.
         * @param $source
         * @param event
         * @param data
         */
        Plugin.prototype.globalSearchCallback = function ($source, event, data) {
            // console.log($source, event, data);
            var tag = new window.ATInternet.Tracker.Tag({ site: this.options.trackId });
            //Take page info from existing tag.
            var pageInfo = this.tag.getContext('page');
            tag.page.set(pageInfo);
            var page = (data.resultCount === 0) ? 0 : data.page;
            var searchKeyword = data.searchTerm === '*' && $source.find('.searchbar__input').val() === '' ? Plugin.prepareText('no keyword provided') : Plugin.prepareText(data.searchTerm);
            tag.internalSearch.set({
                keyword: searchKeyword,
                resultPageNumber: page
            });
            tag.dispatch();
        };
        /**
         * Callback for any filtered search interaction.
         * @param $source
         * @param event
         * @param data
         */
        Plugin.prototype.filteredSearchCallback = function ($source, event, data) {
            this.filteredSearchFilterValues = data.filterValues;
            if (data.noResults) {
                var closestHeadline = this.formatClosestHeadline(this.closestHeadline($source, false));
                this.filteredListVirtualPageView(closestHeadline, 'without_results');
            }
        };
        Plugin.prototype.filteredListVirtualPageView = function (closestHeadline, chapter1) {
            if (chapter1 === void 0) { chapter1 = 'with_results'; }
            var tag = new window.ATInternet.Tracker.Tag({ site: this.options.trackId });
            var pageInfo = {
                name: closestHeadline,
                level2: this.getLevel2Id(),
                chapter1: chapter1
            };
            tag.page.set(pageInfo);
            var filterValues = {};
            this.filteredSearchFilterValues.forEach(function (value, index) {
                filterValues[index + 1] = value;
            });
            tag.customVars.set({ page: filterValues });
            tag.dispatch();
        };
        Plugin.prototype.downloadVirtualPageView = function (destinationUrl) {
            var tag = new window.ATInternet.Tracker.Tag({ site: this.options.trackId });
            var pageInfo = {
                name: 'download',
                level2: '0'
            };
            tag.page.set(pageInfo);
            var customVariable1 = encodeURIComponent('[' + Plugin.stripProtocol(window.location.href) + ']');
            var customVariable3 = encodeURIComponent('[' + Plugin.stripProtocol(destinationUrl) + ']');
            tag.customVars.set({ page: {
                    1: customVariable1,
                    2: '[Download]',
                    3: customVariable3
                } });
            tag.dispatch();
        };
        Plugin.prototype.formSubmitVirtualPageView = function () {
            var tag = this.tag;
            var pageInfo = tag.getContext('page');
            // Dev-Note: added typo "Repsonse" on purpose. It is needed to receive gapless tracking data (since the typo has been in the data before)
            pageInfo.name = pageInfo.name + ' - Repsonse';
            tag.page.set(pageInfo);
            tag.dispatch();
        };
        /**
         * Callback for accordion open action.
         * @param $source
         * @param event
         * @param data
         */
        Plugin.prototype.accordionTabOpenCallback = function ($source, event, data) {
            var isTabbed = ($source.parent('.tabs').length > 0);
            // console.log(source, event, data, source.parent('.tabs'), isTabbed);
            var category = isTabbed ? 'Tabs' : 'Accordion';
            var targetName = $source.find('.accordion__titleLink').text().trim();
            this.sendClickTracking(undefined, 'open', category, 'action', targetName, event);
        };
        /**
         * Callback for accordion close action.
         * @param $source
         * @param event
         * @param data
         */
        Plugin.prototype.accordionCloseCallback = function ($source, event, data) {
            // console.log(source, event, data);
            var targetName = $source.find('.accordion__titleLink').text().trim();
            this.sendClickTracking(undefined, 'close', 'Accordion', 'action', targetName, event);
        };
        /**
         * Callback for teaser click.
         * @param $source
         * @param event
         * @param data
         */
        Plugin.prototype.teaserClickCallback = function ($source, event, data) {
            // console.log('teaserClickCallback');
            var elem = data.sourceElement || $source[0];
            var handoverEvent = data.event || event;
            var chapter3 = data.url || 'teaser';
            var chapter2 = 'Teaser';
            var actionType = 'navigation';
            if (this.isExitLink(data.url))
                actionType = 'exit';
            if ($source.closest('.filteredList').length > 0) {
                var closestHeadline = this.formatClosestHeadline(this.closestHeadline($source, false));
                this.sendClickTracking(elem, 'click', closestHeadline, actionType, chapter3, handoverEvent);
                this.filteredListVirtualPageView(closestHeadline);
            }
            else {
                this.sendClickTracking(elem, 'click', chapter2, actionType, chapter3, handoverEvent);
            }
        };
        Plugin.prototype.psfUpdateCallback = function ($source, event, data) {
            this.psfUpdateObject = data;
            var tag = new window.ATInternet.Tracker.Tag({ site: this.options.trackId });
            tag.page.set(this.tag.getContext('page'));
            tag.customVars.set(this.tag.getContext('page').customVars);
            $source.on('psfResults.resultCount', function (event, resultCount) {
                var page = (resultCount === 0) ? 0 : parseInt(data.of) / data.si + 1;
                tag.internalSearch.set({
                    keyword: Plugin.prepareText(data.q),
                    resultPageNumber: page
                });
                tag.dispatch();
            });
        };
        /**
         * Callback for product and service finder result click.
         * @param $source
         * @param event
         * @param data
         */
        Plugin.prototype.psfResultClickCallback = function ($source, event, data) {
            var tag = new window.ATInternet.Tracker.Tag({ site: this.options.trackId });
            var pageInfo = {
                elem: $source[0],
                name: Plugin.prepareText('PSF Results Details'),
                level2: this.getLevel2Id()
            };
            tag.page.set(pageInfo);
            tag.customVars.set({
                page: {
                    1: Plugin.prepareText('[' + this.psfUpdateObject.q + ']'),
                    2: Plugin.prepareText('[' + this.getActiveFilterValues('facet_psf_hier_industries') + ']'),
                    3: Plugin.prepareText('[' + this.getActiveFilterValues('facet_psf_hier_product_categories') + ']'),
                    4: Plugin.prepareText('[' + this.getActiveFilterValues('facet_psf_type') + ']'),
                    5: Plugin.prepareText('[' + this.getActiveFilterValues('facet_psf_language') + ']'),
                    6: Plugin.prepareText('[' + $.trim($source.closest('.psfSearchResults__item').find('.psfSearchResults__itemTitle a').text()) + ']'),
                    7: encodeURIComponent('[' + Plugin.stripProtocol($source.attr('href')) + ']') // URL der Ergebnisseite
                }
            });
            tag.dispatch();
        };
        Plugin.prototype.closestHeadline = function ($source, findChildren) {
            if ($source.is('body'))
                return undefined;
            if ($source.is('h3'))
                return $source.text();
            if ($source.is('h2'))
                return $source.text();
            if ($source.is('h1'))
                return $source.text();
            if ($source.prevAll('h3').length > 0)
                return $source.prevAll('h3').last().text();
            if ($source.prevAll('h2').length > 0)
                return $source.prevAll('h2').last().text();
            if ($source.prevAll('h1').length > 0)
                return $source.prevAll('h1').last().text();
            if (findChildren) {
                if ($source.find('h3').length > 0)
                    return $source.find('h3').last().text();
                if ($source.find('h2').length > 0)
                    return $source.find('h2').last().text();
                if ($source.find('h1').length > 0)
                    return $source.find('h1').last().text();
            }
            return this.closestHeadline($source.parent(), true);
        };
        Plugin.prototype.formatClosestHeadline = function (closestHeadline) {
            if (closestHeadline)
                closestHeadline = Plugin.prepareText(Plugin.replaceWhiteSpaces(closestHeadline));
            closestHeadline = closestHeadline || 'filtered_search';
            return closestHeadline;
        };
        /**
         * Callback for form submit.
         * @param $source
         * @param event
         * @param data
         */
        Plugin.prototype.formSubmitCallback = function ($formSource, event, data) {
            // console.log('formSubmitCallback', $formSource, event, data);
            var $source = $formSource.find(':submit').first();
            if ($source) {
                var name_1 = 'click';
                var actionType = 'navigation';
                var chapter2 = this.getLinkContext($source);
                var chapter3 = $source.text().trim();
                this.sendClickTracking(undefined, name_1, chapter2, actionType, chapter3, event);
            }
            this.formSubmitVirtualPageView();
        };
        Plugin.prototype.getActiveFilterValues = function (str) {
            var filteredArray = $.grep(this.psfUpdateObject.filter, function (elem, index) {
                return elem.startsWith(str);
            });
            var filterValues = $.map(filteredArray, function (elem, index) {
                return elem.split(':')[1];
            });
            if (str.startsWith('facet_psf_hier')) {
                if (filterValues.length === 0) {
                    filterValues.push('All');
                }
                return filterValues.join('~');
            }
            else {
                return filterValues.join(',');
            }
        };
        /**
         * Obtain level2 id from page tag
         */
        Plugin.prototype.getLevel2Id = function () {
            return this.tag.getContext('page').level2;
        };
        Plugin.prototype.getPageId = function () {
            var page = this.tag.getContext('page');
            if (page.customVars && page.customVars.site && page.customVars.site['4']) {
                return page.customVars.site['4'];
            }
            return null;
        };
        Plugin.replaceWhiteSpaces = function (str) {
            return str.replace(/ /g, '_');
        };
        /**
         * Remove http/https protocol from url.
         * @param url
         */
        Plugin.stripProtocol = function (url) {
            return url.replace('https://', '').replace('http://', '');
        };
        Plugin.prepareText = function (text) {
            return encodeURIComponent(text.replace(/&amp;/g, 'and').replace(/&/g, 'and').replace(/\n/g, ' ').replace(/\t+/g, ' ').replace(/\s+/g, ' '));
        };
        Plugin.NAME = 'tracking';
        return Plugin;
    }());
    $.fn[Plugin.NAME] = function (options) {
        return this.each(function () {
            var $this = $(this);
            if (!$this.data(Plugin.NAME)) {
                $this.data(Plugin.NAME, new Plugin(this, options));
            }
        });
    };
})(jQuery, window, document);


/***/ })

/******/ });
//# sourceMappingURL=jquery.tracking.js.map